import { Auth } from 'aws-amplify';

const LOCAL_STORAGE_TOKEN = 'guest_token';

const clearToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_TOKEN);
  localStorage.removeItem('api-token');
};

const getToken = () => {
  return new Promise((resolve, reject) => {
    const apiToken = getApiToken();
    if (apiToken) {
      resolve(apiToken);
    } else {
      Auth.currentSession()
        .then((session: any) => {
          const { jwtToken } = session?.idToken;
          resolve(jwtToken);
        })
        .catch(err => {
          console.log(err);
          localStorage.removeItem('api-token');
          reject();
        });
    }
  });
};

const getApiToken = () => {
  const token = localStorage.getItem('api-token');
  if (!token) return '';
  return token;
};

const setApiToken = (token: string) => {
  localStorage.setItem('api-token', token);
};

export default {
  clearToken,
  getToken,
  getApiToken,
  setApiToken,
};
